module.exports = __webpack_public_path__ + "static/media/iconmonstr-github-rounded.96f4c70d.svg";